<template>
  <div>
    <button @click="select" :class="'reward ' + sold"  v-if="reward">
      <div v-if="reward.photo.url">
        <img class="reward-image" :src="$server_url + reward.photo.url" alt="">
      </div>
      <p class="sold-out">{{ $t('reward.soldOut') }}</p>
      <h3>{{ project.currency | currencySymbol }}{{ reward.price }}</h3>
      <h4>{{ reward.title }}</h4>
      <p>{{ reward.description }}</p>
      <p><strong>{{ reward.contributions_count }} {{ $t('reward.contributions') }} ( {{ $t('reward.left') }}: {{ rewardLeft }} )</strong></p>
      <p v-if="project.crowdfunding" class="get">{{ $t("reward.getReward") }}</p>
      <p v-else class="get">{{ $t("reward.donate") }}</p>
    </button>
    <button @click="select" v-else type="button" class="btn btn-default btn-lg button-wide">
      {{ $t("project.show.contributeButton") }}
    </button>
    <!-- Modal -->
    <transition v-if="selected" name="modal">
      <form @submit.prevent="contribute()">
        <modal v-show="!shippingModal" :close="close" class="modal-wide">
          <h3 slot="header">{{ $t('reward.contribute') }}</h3>

          <div slot="body" class="row" style="align-items: flex-start;">
            <div class="col-md-6">
							<label>
								<img src="~assets/img/przelewy24.png"><br>
								<input v-model="paymentType" type="radio" name="payment-method" id="payment-przelewy24" value="P24">
								Przelew online
							</label>
							<p>od transakcji pobierana jest prowizja ok. 3,9% wartości transakcji + 50 gr</p>
							<hr>
							<label>
								<img src="~assets/img/mastercard-visa.png" alt="MasterCard, VISA"><br>
								<input v-model="paymentType" type="radio" name="payment-method" id="payment-credit-card" value="CB_VISA_MASTERCARD">
								Płatność kartą MasterCard / VISA
							</label>
              <p>od transakcji pobierana jest prowizja ok. 3,9% wartości transakcji + 1 zł</p>
              <hr>
              <div v-if="project.currency !== 'PLN'">
                <label>
                  <img src="~assets/img/maestro.png" alt="Maestro"><br>
                  <input v-model="paymentType" type="radio" name="payment-method" id="payment-maestro" value="MAESTRO">
                  Płatność kartą Maestro
                </label>
                <p>od transakcji pobierana jest prowizja ok. 3,9% wartości transakcji + 1 zł</p>
              </div>
              <hr>
							<div v-if="project.currency !== 'PLN'">
                <label>
                  <img src="~assets/img/diners-club.png" alt="Diners Club International"><br>
                  <input v-model="paymentType" type="radio" name="payment-method" id="payment-diners" value="DINERS">
                  Płatność kartą Diners Club International
                </label>
                <p>od transakcji pobierana jest prowizja ok. 3,9% wartości transakcji + 1 zł</p>
                <p>Płatności są obsługiwane przez:</p>
              </div>
							<img class="sm-100-w" src="~assets/img/powered-by-mangopay.png" alt="MANGOPAY, Credit Mutuel ARKEA, Payline"><br>
							<hr>
				    </div>
            <div class="col-md-6">
              <h3 v-if="reward" style="text-align: center">{{ reward.title }}</h3>
              <h3 v-else style="text-align: center">{{ $t('reward.contribute') }}</h3>
              <br>
              <h5 v-if="reward" >{{ $t('reward.minimumPrice') }}
                <span><b>{{ reward.price }} {{ project.currency | currencySymbol }}</b></span>
                <br/><br/>
                {{ $t('reward.additionalPrice') }}
                <span v-if="reward"><b>{{ reward.price }} {{ project.currency | currencySymbol }}</b></span>
              </h5>
              <alert :error="alert.error" :success="alert.success"></alert>
              <h3>
                <div class="input-group">
                  <input type="number" :placeholder="$t('price')" v-model="contribution" autofocus style="width:100%;padding:15px"/>
                  <div class="input-group-addon"><h4>{{ project.currency }}</h4></div>
                </div>
              </h3>
              <checkbox v-model="anonymous">
                <span slot="label">{{ $t('contribution.anonymous') }}</span>
              </checkbox>
              <div v-if="!user.light_kyc_valid">
                <h5 class="mb-20 mt-30">
                  <strong>
                    {{ user.full_name }}
                    <br>
                    {{ user.email }}
                  </strong>
                </h5>
                <datepicker v-model="user.birthday"
                  format="yyyy-MM-dd"
                  :typeable="false"
                  :language="datapickerLang"
                  class="mb-20"
                  input-class="form-control"
                  :placeholder="$t('profile.edit.birthday')">
                </datepicker>
                <select v-if="countries.length" v-model="user.country_id" class="form-control mb-20">
  								<option disabled value="">{{ $t('country') }}</option>
  								<option v-for="country in countries" :value="country.id">{{ country.name }}</option>
  							</select>
                <select v-if="countries.length" v-model="user.country_of_residence_id" class="form-control mb-20">
                  <option disabled value="">{{ $t('countryOfResidence') }}</option>
                  <option v-for="country in countries" :value="country.id">{{ country.name }}</option>
                </select>
              </div>
              <div class="pt-5">
                <checkbox v-model="domoreConsent">
                  <b slot="label">{{ $t('project.verification.acceptRules') }}</b>
                </checkbox>
                <checkbox v-model="mangopayConsent">
                  <b slot="label">{{ $t('project.verification.acceptMangopayRules') }}</b>
                </checkbox>
              </div>
            </div>
          </div>
          <!-- END OF BODY  -->

          <div slot="footer" style="display: inline">
            <button v-if="reward && !address" type="button" @click="showShippingModal()" class="btn btn-primary" :disabled="show_loader || !KYCprovided" style="width: 100px; margin: 5px">
              <span v-if="!show_loader">{{ $t('reward.shipping') }}</span>
              <clip-loader :loading="show_loader" :color="'#fff'" :size="'15px'"></clip-loader>
            </button>
            <button v-if="!reward || address" type="submit" class="btn btn-primary" :disabled="show_loader" style="width: 100px; margin: 5px">
              <span v-if="!show_loader">{{ $t('reward.contribute') }}</span>
              <clip-loader :loading="show_loader" :color="'#fff'" :size="'15px'"></clip-loader>
            </button>
          </div>
        </modal>
        <modal v-if="shippingModal" :close="close" class="modal-wide">
          <h3 slot="header">{{ $t('reward.address') }}</h3>
          <div slot="body" class="row">
            <delivery-address :countries="countries" @onChange="setDeliveryAddress" class="col-xs-12"/>
          </div>
          <div slot="footer" style="display: inline">
            <button @click="closeShippingModal" type="button" class="btn btn-default" :disabled="show_loader" style="width: 61px">
              <span>{{ $t('back') }}</span>
            </button>
            <button type="submit" class="btn btn-primary" :disabled="show_loader || !deliveryAddress.id" style="width: 100px; margin: 5px">
              <span v-if="!show_loader">{{ $t('reward.contribute') }}</span>
              <clip-loader :loading="show_loader" :color="'#fff'" :size="'15px'"></clip-loader>
            </button>
          </div>
        </modal>
      </form>
    </transition>
    <!-- Modal Log In-->
    <login-modal v-if="show_login" :close="closeLogin"></login-modal>
  </div>
</template>

<script>
// API
import contributionsApi from '@/api/v1/contributions';
import auth from '@/api/v1/auth/authService';
import userApi from '@/api/v1/user';
import dictionariesApi from '@/api/v1/shared/dictionaries';
// Components
import Modal from '@/components/Modal';
import DeliveryAddress from '@/components/Profile/DeliveryAddress';
import Alert from '@/components/Alert';
import Checkbox from '@/components/Utils/Inputs/Checkbox';
import ClipLoader from 'vue-spinner/src/ClipLoader';
import LoginModal from '@/components/Header/LoginModal';
import Datepicker from 'vuejs-datepicker';
import { pl, en } from 'vuejs-datepicker/src/locale';
// Models
import userModel from '@/models/user';
// Mixins
import alert from '@/mixins/alert';

export default {
  props: ['reward', 'project', 'amount'],
  mixins: [alert],
  components: { Modal, Alert, ClipLoader, LoginModal, Datepicker, DeliveryAddress, Checkbox },
  data() {
    return {
      anonymous: false,
      selected: false,
      address: false,
      show_loader: false,
      show_login: false,
      paymentType: 'CB_VISA_MASTERCARD',
      contribution: this.reward ? this.reward.price : this.amount,
      user: userModel.user,
      countries: [],
      shippingModal: false,
      deliveryAddress: {},
      userCountry: {},
      domoreConsent: false,
      mangopayConsent: false,
    };
  },
  computed: {
    rewardLeft() {
      return this.reward.quantity - this.reward.contributions_count;
    },
    datapickerLang() {
      return localStorage.getItem('lang') === 'en' ? en : pl;
    },
    sold() {
      const active =
        new Date(this.project.deadline) > new Date() || !this.project.deadline;
      const sold = this.reward.quantity <= this.reward.contributions_count;
      return !active || sold ? 'sold' : '';
    },
    KYCprovided() {
      const user = this.user;
      return user.birthday && user.country_of_residence_id && user.country_id;
    },
  },
  methods: {
    setUserCountry() {
      if (this.user.country_of_residence_id) {
        this.userCountry = this.countries.find(
          country => country.id === this.user.country_of_residence_id,
        ).name;
        if (this.userCountry) { this.user.country = this.userCountry; }
      }
    },
    checkConsents() {
      return this.mangopayConsent && this.domoreConsent;
    },
    contribute() {
      this.clearAlerts();

      if (!this.checkConsents()) {
        this.shippingModal = false;
        this.alert.error = this.$t('project.verification.acceptRulesError');
        return;
      }

      this.show_loader = true;
      const data = {
        amount: Number(this.contribution),
        anonymous: this.anonymous,
        payment_type: this.paymentType,
        delivery_address_id: this.deliveryAddress.id,
      };

      let validContribution = this.contribution > 0;
      if (this.reward) {
        validContribution = this.contribution >= this.reward.price;
        const validKYC = this.user.light_kyc_valid;
        data.reward_id = this.reward.id;
        if (!validContribution) {
          this.shippingModal = false;
          this.alert.error = this.$t('reward.priceTooLowAlert');
        } else if (!validKYC) {
          this.shippingModal = false;
          this.alert.error = this.$t('reward.validKYC');
        }
      }

      if (validContribution) {
        this.updateUser().then(() => {
          contributionsApi
            .new(this.project.id, data)
            .then((response) => {
              location.href = response.data.redirect_url;
            })
            .catch((response) => {
              this.show_loader = false;
              this.address = false;
              this.shippingModal = false;
              const error = response.response.data;
              try {
                this.alert.error = error[Object.keys(error)[0]][0];
              } catch (e) {
                this.alert.error = this.$t('errors.general');
              }
            });
        });
      } else {
        this.alert.error = this.$t('reward.priceTooLowAlert');
        this.show_loader = false;
        this.address = false;
      }
    },
    select() {
      // if user is not logged in show login modal
      if (!auth.user.authenticated) {
        this.close();
        this.show_login = true;
        return;
      }
      if (this.reward) {
        if (!this.sold) this.selected = true;
      } else {
        this.selected = true;
      }
    },
    close() {
      this.clearAlerts();
      this.selected = false;
      this.shippingModal = false;
    },
    closeLogin() {
      this.show_login = false;
    },
    setUser(user) {
      user.address = this.user.address_line_1;
      this.user = user;
      this.user.country_id = this.user.country_id || '';
      this.user.country_of_residence_id =
        this.user.country_of_residence_id || '';
    },
    updateUser() {
      return userApi.updateUser(this.user)
        .then(() => {
          this.processing = false;
          userApi.myProfile(this.setUser);
        })
        .catch((response) => {
          this.processing = false;
          this.errors = response.response.data;
        });
    },
    closeShippingModal() {
      this.shippingModal = false;
      this.address = false;
    },
    showShippingModal() {
      this.shippingModal = true;
    },
    setDeliveryAddress(deliveryAddress) {
      this.deliveryAddress = deliveryAddress;
    },
  },
  watch: {
    user() {
      this.setUserCountry();
    },
    amount() {
      this.contribution = this.amount;
    },
  },
  created() {
    userApi.myProfile(this.setUser);
    dictionariesApi.getCountries((countries) => {
      this.countries = countries;
      this.setUserCountry();
    });
  },
};
</script>



// WEBPACK FOOTER //
// Contribute.vue?38da9081